import { useContext, useState, useEffect } from "react";
import { Context_UI } from "../../Contexts/Context_UI";

export default function UI_Divider({
    id,
    Text,
    DoubleColumns
}) {
    const UI = useContext(Context_UI);

    return (
        <>
            {DoubleColumns ?
                <div className="General_Divider_Component"></div>
                :
                ""
            }
            <div className="General_Divider" id={id} hasText={Text ? "hasText" : undefined}>
                <div className="General_Divider_Component"></div>
                {Text ?
                    <p className="General_Divider_Text">
                        {Text}
                    </p>
                    :
                    ""
                }
                <div className="General_Divider_Component"></div>
            </div>
        </>
    );
}
